var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusMessage = function SvgStatusMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M4 13.302h4.013a.05.05 0 0 0 .047-.035l.798-2.599a.05.05 0 0 1 .095 0l1.913 6.187c.014.046.08.046.095 0l2.967-9.691a.05.05 0 0 1 .096 0l1.916 6.103a.05.05 0 0 0 .048.035H20"
  })));
};
export default SvgStatusMessage;